export const uiTokens = {
  palette: {
    obsidian: {
      950: '#05070d',
      900: '#0a111c',
      800: '#0f1826',
      700: '#121f31',
    },
    emerald: {
      500: '#37f287',
    },
    amber: {
      500: '#f7d15a',
    },
    red: {
      500: '#ff6565',
    },
    cyan: {
      400: '#63d8ff',
    },
    slate: {
      300: '#9ab0c8',
      400: '#7f93ac',
      500: '#6f829d',
      600: '#5f7591',
      700: '#1a2538',
    },
  },
  colors: {
    bg: '#05070d',
    surface: '#0a111c',
    surface2: '#0f1826',
    surface3: '#121f31',
    text: '#d5e4f4',
    muted: '#7f93ac',
    primary: '#37f287',
    warning: '#f7d15a',
    danger: '#ff6565',
    info: '#63d8ff',
  },
  semantic: {
    background: {
      canvas: 'var(--cc-bg)',
      surface: 'var(--cc-surface)',
      surfaceContainer: 'var(--cc-surface-2)',
      surfaceContainerHigh: 'var(--cc-surface-3)',
    },
    text: {
      primary: 'var(--cc-text)',
      muted: 'var(--cc-muted)',
      subtle: 'var(--cc-text-subtle)',
      secondary: 'var(--cc-text-secondary)',
    },
    status: {
      ok: {
        bg: 'var(--cc-status-ok-bg)',
        fg: 'var(--cc-status-ok-fg)',
      },
      warn: {
        bg: 'var(--cc-status-warn-bg)',
        fg: 'var(--cc-status-warn-fg)',
      },
      danger: {
        bg: 'var(--cc-status-danger-bg)',
        fg: 'var(--cc-status-danger-fg)',
      },
      info: {
        bg: 'var(--cc-status-info-bg)',
        fg: 'var(--cc-status-info-fg)',
      },
      neutral: {
        bg: 'var(--cc-status-neutral-bg)',
        fg: 'var(--cc-status-neutral-fg)',
      },
    },
  },
  radius: {
    lg: '16px',
    md: '14px',
    sm: '12px',
  },
  spacing: {
    pageX: 'p-4 xl:p-6',
    sectionGap: 'gap-4',
    cardPadding: 'p-4 md:p-5',
  },
  typography: {
    eyebrow: 'text-[10px] font-semibold uppercase tracking-[0.18em] text-[#6f829d]',
    heading: 'text-2xl md:text-3xl font-semibold tracking-tight text-[#e7f0fa]',
    body: 'text-sm text-[#8ea3bd]',
  },
  glow: {
    primary: 'shadow-[0_10px_30px_-12px_rgba(55,242,135,0.75)]',
  },
};

export const surfaceClasses = {
  shell: 'cc-command-shell',
  panel: 'cc-tonal-panel',
  panelSoft: 'cc-tonal-panel-soft',
};
